import gql from 'graphql-tag';

const NAME = 'inventoryDeltas';
const FRAGMENT = `
  fragment ${NAME} on InventoryDeltas {
    deltas {
      cubesheetItemId
      quantity
      homeArea
    }
  }
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
